// extracted by mini-css-extract-plugin
export var disabledNavigator = "NewsSection-module--disabledNavigator--cbdad";
export var navigator = "NewsSection-module--navigator--35ae4";
export var newsHolder = "NewsSection-module--newsHolder--d5cb4";
export var newsItem = "NewsSection-module--newsItem--c66f7";
export var newsItemContent = "NewsSection-module--newsItemContent--859b1";
export var newsNavBtn = "NewsSection-module--news-nav-btn--391b6";
export var newsNavigator = "NewsSection-module--news-navigator--845ee";
export var newsRoll = "NewsSection-module--newsRoll--202d7";
export var title = "NewsSection-module--title--b8845";
export var titleWrapper = "NewsSection-module--titleWrapper--10032";
export var wrapper = "NewsSection-module--wrapper--0452e";